'use client';
import Image from 'next/image';
import { useState } from 'react';

const PLACEHOLDER = '/achievements/_placeholder.png';

interface Props {
  iconFile: string;
  alt: string;
  size?: number;
  fill?: boolean;
  className?: string;
  onLoad?: () => void;
}

export function AchievementIcon({ iconFile, alt, size = 96, fill, className, onLoad }: Props) {
  const [erroredFile, setErroredFile] = useState<string | null>(null);
  const src = erroredFile === iconFile ? PLACEHOLDER : `/achievements/${iconFile}`;
  const onError = () => setErroredFile(iconFile);

  if (fill) {
    return (
      <Image src={src} fill sizes="60vw" quality={90} alt={alt} className={className} onError={onError} onLoad={onLoad} />
    );
  }
  return (
    <Image
      src={src}
      width={size}
      height={size}
      sizes={`${size}px`}
      quality={90}
      alt={alt}
      className={className}
      onError={onError}
      onLoad={onLoad}
    />
  );
}
